module.exports = __webpack_public_path__ + "static/media/Coastline-3581.6ca18c92.mp4";